
import { ENUMS } from "../../utils/Enums";
import { FILTER } from "../../utils/Struct";
import Input from "../../ui/Input";
import Button from "../../ui/Button";
import Space from "../../ui/Space";
import DateField from "../../ui/DateField";
import SelectBox from "../../ui/SelectBox";
import FilterBase from "./FilterBase";
import { bm_date } from "../../utils/Utils";

export default function GenericDoubleValue(props) {
    
    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, allow_in = false, date = false, edit = false, inputParams = { number: true, maxLength: 3, width: 200 }, dayParams = { number: true, maxLength: 2, width: 10} } = props;

    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let text2 = filter.text2;
    let text3 = filter.text3;

    let _data = ENUMS.CUSTOMER_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
        text2 = _data.text2;
        text3 = _data.text3;
    }

    const fields = [
        { key: "value_1", value: (edit) ? filter.value_1 : "", help: "" },
        { key: "value_2", value: (edit) ? filter.value_2 : (inputParams.number) ? "" : "", help: "Enter the data to complete this filter." },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const value_1 = tabs.find(f => f.key === "value_1").value;
        const value_2 = tabs.find(f => f.key === "value_2").value;


        const _f = {
            ...FILTER,
            type: value,
            value_1: value_1,
            value_2: value_2.toString()
        }
        onSave(_f, filter);
    }

    return (
        <FilterBase controller={controller} start_index={0} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, refs, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        {(!date && <Input {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />)}
                        <span>{text2}</span>
                        {(!date && <Input {...editProps("value_2")} {...dayParams} onFill={(e) => proceed(e)} />)}
                        <span>{text3}</span>
                        <Button onClick={() => save(tabs)} {...editProps("save")} >Save</Button>
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}